export enum Verguetungsart {
    EEG = 'EEG',
    KWKG = 'KWKG',
    SONSTIGES = 'SONSTIGES'
}

export class VerguetungsartItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): VerguetungsartItem[] {
        return [
            new VerguetungsartItem(Verguetungsart.EEG, 'Z01 = EEG'),
            new VerguetungsartItem(Verguetungsart.KWKG, 'Z02 = KWKG'),
            new VerguetungsartItem(Verguetungsart.SONSTIGES, 'Z03 = Sonstiges'),
        ];
    }

}

